export const partnerMerchants = {
  topPicks: [
    { 
      link:'http://amazon.co.uk/',
      alt: 'Amazon Logo',
      logo:'https://cdn.shippingcart.com/assets/amazon-20191216085009.svg'
    },
    { 
      link:'https://www.ebay.co.uk/',
      alt: 'Ebay Logo',
      logo:'https://cdn.shippingcart.com/assets/ebay-20191216085009.svg'
    },
    { 
      link:'https://www.asos.com/women/',
      alt: 'Asos Logo',
      logo:'https://cdn.shippingcart.com/assets/asos-20191216085009.svg'
    },
    { 
      link:'https://www.tkmaxx.com/uk/en/',
      alt: 'TKmaxx Logo',
      logo:'https://cdn.shippingcart.com/assets/tkmaxx-20200116055236.svg'
    },
  ],
  fashionBeauty: [
    { 
      link:'https://www.allbirds.co.uk/collections/womens',
      alt: 'All Birds Logo',
      logo:'https://cdn.shippingcart.com/assets/allbirds-20191216085009.svg'
    },
    { 
      link:'https://athleta.gap.com/',
      alt: 'Athleta Logo',
      logo:'https://cdn.shippingcart.com/assets/athleta-20191216085009.svg'
    },
    { 
      link:'https://www.barneys.com/',
      alt: 'Barneys Logo',
      logo:'https://cdn.shippingcart.com/assets/barneys-new-york-20191216085010.svg'
    },
    { 
      link:'https://www.brora.co.uk/',
      alt: 'Brora Logo',
      logo:'https://cdn.shippingcart.com/assets/brora-20191216085009.svg'
    },
    { 
      link:'https://www.brummellsoflondon.com/',
      alt: 'Brummell of London Logo',
      logo:'https://cdn.shippingcart.com/assets/brummellsoflondon-20191216085010.svg'
    },
    { 
      link:'https://www.cultbeauty.co.uk/',
      alt: 'Cult Beauty Logo',
      logo:'https://cdn.shippingcart.com/assets/cult-beauty-20191216085010.svg'
    },
    { 
      link:'https://www.dunelondon.com/',
      alt: 'Dune London Logo',
      logo:'https://cdn.shippingcart.com/assets/dunelondon-20191216085009.svg'
    },
    { 
      link:'https://www.coggles.com/',
      alt: 'Coggles Logo',
      logo:'https://cdn.shippingcart.com/assets/coggles-20200116055236.svg'
    },
    { 
      link:'https://www.eastex.co.uk/',
      alt: 'Eastex Logo',
      logo:'https://cdn.shippingcart.com/assets/eastex-20191216085009.svg'
    },
    { 
      link:'https://www.evelom.com/',
      alt: 'Evelom Logo',
      logo:'https://cdn.shippingcart.com/assets/evelom-20191216085009.svg'
    },
    { 
      link:'https://www.footlocker.com/',
      alt: 'Footlocker Logo',
      logo:'https://cdn.shippingcart.com/assets/footlocker-20191216085009.svg'
    },
    { 
      link:'https://www.footasylum.com/',
      alt: 'Foot Asylum Logo',
      logo:'https://cdn.shippingcart.com/assets/footasylum-20191216085010.svg'
    },
    { 
      link:'https://www.harrods.com/en-gb',
      alt: 'Harrods Logo',
      logo:'https://cdn.shippingcart.com/assets/harrods-20191216085010.svg'
    },
    { 
      link:'https://www.isabellaoliver.com/eu',
      alt: 'Issabella Oliver Logo',
      logo:'https://cdn.shippingcart.com/assets/isabella-oliver-20191216085010.svg'
    },
    { 
      link:'https://www.jacques-vert.co.uk/',
      alt: 'Jacques Vert Logo',
      logo:'https://cdn.shippingcart.com/assets/jacques-vert-20191216085010.svg'
    },
    { 
      link:'https://www.jdsports.co.uk/',
      alt: 'JDsports Logo',
      logo:'https://cdn.shippingcart.com/assets/jd-sports-20191216085009.svg'
    },
    { 
      link:'https://www.kickers.co.uk/',
      alt: 'Kickers Logo',
      logo:'https://cdn.shippingcart.com/assets/kickers-20191216085010.svg'
    },
    { 
      link:'https://www.kurtgeiger.com/',
      alt: 'Kurt Geiger Logo',
      logo:'https://cdn.shippingcart.com/assets/kurt-geiger-20191216085009.svg'
    },
    { 
      link:'http://www.linksoflondon.com/',
      alt: 'Links of London Logo',
      logo:'https://cdn.shippingcart.com/assets/links-of-london-20191216085010.svg'
    },
    { 
      link:'https://www.longchamp.com/gb/en',
      alt: 'Longchamp Logo',
      logo:'https://cdn.shippingcart.com/assets/longchamp-paris-20191216085010.svg'
    },
    { 
      link:'https://www.longtallsally.com/?gclid=EAIaIQobChMI-qOr3PaM3QIVloePCh2hmgv2EAAYASAAEgL4TvD_BwE',
      alt: 'Long Tall Sally Logo',
      logo: 'https://cdn.shippingcart.com/assets/long-tall-sally-20191216085010.svg'
    },
    { 
      link:'https://www.mainlinemenswear.co.uk/',
      alt: 'Mainline Menswear Logo',
      logo:'https://cdn.shippingcart.com/assets/mainline-mens-wear-20191216085010.svg'
    },
    { 
      link:'https://www.marksandspencer.com/',
      alt: 'Marks and Spencer Logo',
      logo:'https://cdn.shippingcart.com/assets/marks-and-spencer-20191216085010.svg'
    },
    { 
      link:'https://www.quizclothing.co.uk/',
      alt: 'Quiz Clothing Logo',
      logo:'https://cdn.shippingcart.com/assets/quiz-clothing-20191216085010.svg'
    },
    { 
      link:'https://nelly.com/uk/womens-fashion/brands/rare-london-475/',
      alt: 'Rare Londo Logo',
      logo:'https://cdn.shippingcart.com/assets/rare-london-20191216085013.svg'
    },
    { 
      link:'https://www.ratandboa.com/',
      alt: 'Rat and Boa Logo',
      logo:'https://cdn.shippingcart.com/assets/rat-and-boa-20200116055236.svg'
    },
    { 
      link:'https://www.reiss.com/',
      alt: 'Reiss Logo',
      logo:'https://cdn.shippingcart.com/assets/reiss-20191216085010.svg'
    },
    { 
      link:'https://www.schuh.eu/en-eu/',
      alt: 'Schuh Logo',
      logo:'https://cdn.shippingcart.com/assets/schuh-20191216085010.svg'
    },
    { 
      link:'https://www.speedo.com/international/en',
      alt: 'Speedo Logo',
      logo:'https://cdn.shippingcart.com/assets/speedo-20191216085010.svg'
    },
    { 
      link:'https://www.sweatybetty.com/',
      alt: 'Sweaty Betty Logo',
      logo:'https://cdn.shippingcart.com/assets/sweaty-betty-london-20191216085010.svg'
    },
    { 
      link:'https://www.warehouse-london.com/row/home',
      alt: 'Warehouse London Logo',
      logo:'https://cdn.shippingcart.com/assets/warehouse-london-20191216085012.svg'
    },
    { 
      link:'https://www.zalando.co.uk/',
      alt: 'Zalando Logo',
      logo:'https://cdn.shippingcart.com/assets/zalando-20191216085010.svg'
    },
    { 
      link:'https://www.zavvi.com/',
      alt: 'Zavvi Logo',
      logo:'https://cdn.shippingcart.com/assets/zavvi-20200116055236.svg'
    },
  ],
  home: [
    { 
      link:'https://www.crateandbarrel.com/',
      alt: 'Crate and Barrel Logo',
      logo:'https://cdn.shippingcart.com/assets/crate-barrel-20191216085010.svg'
    },
    { 
      link:'https://www.oka.com/',
      alt: 'Oka Logo',
      logo:'https://cdn.shippingcart.com/assets/oka-20191216085011.svg'
    },
    { 
      link:'https://www.barnesandnoble.com/',
      alt: 'Barnes and Noble Logo',
      logo:'https://cdn.shippingcart.com/assets/barnes-noble-20191216085010.svg'
    },
    { 
      link:'https://www.thebookpeople.co.uk/webapp/wcs/stores/servlet/qs_home_tbp?storeId=10001&amp;catalogId=10051&amp;langId=100',
      alt: 'The Book People Logo',
      logo:'https://cdn.shippingcart.com/assets/the-book-people-20191216085013.svg'
    },
    { 
      link:'https://www.made.com/',
      alt: 'Made Logo',
      logo:'https://cdn.shippingcart.com/assets/made-20200116055236.svg'
    },
  ],
  tech: [
    { 
      link:'https://www.zagg.com/us/en_us/',
      alt: 'Zagg Logo',
      logo:'https://cdn.shippingcart.com/assets/zagg-20191216085012.svg'
    }
  ],
}

export const banners = [
  {
    img: 'https://cdn.shippingcart.com/assets/origin-banner-large-20200128071132.jpg',
    alt: 'origin-banner-large',
    customClass: 'large-banner',
  },
  {
    img: 'https://cdn.shippingcart.com/assets/origin-banner-small-20200128071132.jpg',
    alt: 'origin-banner-small',
    customClass: 'small-banner',
  }
]


/** WEBPACK FOOTER **
 ** ./src/components/UKShopping/constants.js
 **/